Wee.fn.make('miniCart:baseCart', {
	init: function() {
		var priv = this.$private;

		priv.createMiniCart();
		priv.initEvents();
	}
}, {
	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$.history.bind({
			click: 'ref:miniCartButton'
		});

		$.events.on({
			'ref:miniCartQuantity': {
				change: function(e, el) {
					scope.changeMiniCartQuantity(e, el);
				},
				click: function(e, el) {
					scope.changeMiniCartQuantity(e, el);
				}
			},

			'ref:miniCartButton': {
				click: function() {
					$.history.go({
						path: $._win.location.origin + '/quote'
					});

					$('ref:miniCart').hide();
				}
			}
		}, {
			delegate: 'ref:miniCart'
		});

		$('ref:body').on('click', function(e) {
			var $miniCart = $('ref:miniCart');

			if (! Wee.$parents(e.target, $miniCart).length) {
				$miniCart.hide();
			}
		});
	},

	updateCartData: function() {
		this.app.$pause();
		this.app.$set('items', this.$public.store.get('items'));
		this.app.$set('total', this.$public.model());
		this.app.$resume(true);
	},

	/**
	 *	Render list of products in quote
	 *
	 * @private
	 */
	createMiniCart: function() {
		this.app = Wee.app.make('mini-cart', {
			target: 'ref:miniCart',
			view: 'mini-cart',
			model: this.$public.model()
		});
	},

	changeMiniCartQuantity: function(e, el) {
		var scope = this,
			$el = $(el),
			count = $el.val(),
			app = scope.app,
			index = $el.parents('ref:miniCartItem').data('index'),
			priceSplit = app.$get('items.' + index + '.productPrice').split(',').join(''),
			productPrice = parseFloat(priceSplit);

		scope.syncItems(scope.app, 'items.' + index + '.productQuantity', count);
		scope.syncItems(scope.app, 'items.' + index + '.totalPrice', (count * productPrice));
		scope.app.$set(scope.$public.model());
	}
});